import get from "lodash/get";

export namespace ScreenHelper {
  export const scrollIntoScreenById = (id: string): void => {
    console.log('scrollIntoScreenById(%s)', id);
    let resultListContainer = document.querySelector('.result-list-items');
    let elementTopPos = get(document.getElementById(id), 'parentNode.offsetTop', 0);

    window.scrollTo(0, get(document.querySelector('#nzpost-react-pkl'), 'offsetTop', 0));
    if (resultListContainer) {
      resultListContainer.scrollTo(0, elementTopPos);
    }
  }

}





// WEBPACK FOOTER //
// ./src/utilities/ScreenHelper.tsx